import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import myImg from "assets/avatar.svg"
import Tilt from "react-parallax-tilt"
import localization from "utils/localization"
import { Link } from "react-router-dom"
import { ROUTES } from "constants/general"

const History = () => (
    <Container fluid className="home-about-section" id="about">
        <Container>
            <Row>
                <Col md={8} className="home-about-description">
                    <h1 style={{ fontSize: "2.6em" }}>
                        { localization('a-little-bit-of') } <span className="purple"> { localization('my-story') }</span>
                    </h1>
                    <p className="home-about-body">
                        { localization('about-me-1') }
                        <br/>
                        <br/>
                        { localization('about-me-2') } <b className="purple">{ localization('about-me-3') }</b>
                        <br />
                        <br />
                        { localization('about-me-4') } <b className="purple">{ localization('about-me-5') }</b>, { localization('about-me-6') }
                        <br />
                        <br />
                        { localization('about-me-7') } <a href="https://thebrooklynbrothers.com/" target="_blank" rel="noreferrer"><b className="purple">{ localization('tbb') }</b></a>, { localization('about-me-8') }
                        <br />
                        <br />
                        { localization('about-me-9') } <a href="https://www.sicoob.com.br/web/sicoobcredisulca" target="_blank" rel="noreferrer"><b className="purple">{ localization('credisulca') }</b></a>
                        . { localization('about-me-10') } <Link to={ ROUTES[1].to }>{ localization('projects') }</Link>.
                        <br />
                        <br />
                        { localization('about-me-11') } <a href="https://www.bcb.gov.br/detalhenoticia/269/noticia" target="_blank" rel="noreferrer"><b className="purple">{ localization('cidadata') }</b></a>, { localization('about-me-12') }
                        <br />
                        <br />
                        { localization('about-me-13') } <a href="https://metalpass.com.br/" target="_blank" rel="noreferrer">
                        <b className="purple">{ localization('metalpass') }</b></a>, { localization('about-me-14') }
                        <br />
                        <br />
                        { localization('about-me-15') }
                        <br />
                        <br />
                        { localization('about-me-16') }
                        <br />
                        <br />
                    </p>
                </Col>
                <Col md={4} className="myAvtar">
                    <Tilt>
                        <img src={ myImg } className="img-fluid" alt="avatar" />
                    </Tilt>
                </Col>
            </Row>
        </Container>
    </Container>
)

export default History